import { Job } from "../../common/apis/dtos";
import { Grid } from "@mui/material";
import { CargoSummaryItem } from '../../common/components/cargoSummaryItem/CargoSummaryItem';
import '../../common/utilities/Section.scss';
import './CargoSummary.scss';
import { useTranslation } from '@chr/online-shared-ui-localizations';

export interface CargoSummaryProps {
    shipment: Job;
    isMobileScreen: boolean;
}

export const CargoSummary = ({ shipment, isMobileScreen }: CargoSummaryProps) => {
    const translate = useTranslation();
    const actualWeight = shipment.cargoSummary.actualWeight;
    const chargeableWeight = shipment.cargoSummary.chargeableWeight;
    const outerPackQuantity = shipment.cargoSummary.outerPackQuantity?.toString() ?? '';
    const uom = shipment.cargoSummary.uom;

    const cargoSummaryItems = () => {
        return (
          <Grid
            container
            spacing={2}
            className="cargo-summary-items-section"
            data-testid="cargo-summary-items-section"
            alignItems={'flex-start'}
            justifyContent={'flex-start'}
          >
            <Grid item xs={isMobileScreen ? 12 : 3}>
              <CargoSummaryItem
                title={translate('Actual Weight')}
                measurementToDisplay={actualWeight}
                isWeight={true}
                isMobileScreen={isMobileScreen}
              />
            </Grid>
            <Grid item xs={isMobileScreen ? 12 : 3}>
              <CargoSummaryItem
                title={translate('Chargeable Weight')}
                measurementToDisplay={chargeableWeight}
                isWeight={true}
                isMobileScreen={isMobileScreen}
              />
            </Grid>
            <Grid item xs={isMobileScreen ? 12 : 3}>
              <CargoSummaryItem
                title={translate('Outer pack quantity')}
                textToDisplay={outerPackQuantity}
                isMobileScreen={isMobileScreen}
              />
            </Grid>
            <Grid item xs={isMobileScreen ? 12 : 3}>
              <CargoSummaryItem
                title={translate('UoM')}
                textToDisplay={uom}
                isMobileScreen={isMobileScreen}
              />
            </Grid>
          </Grid>
        );
      };
    
      return (
        <div data-testid="cargo-summary" className="section cargo-summary-section">
          <div className="section-heading">{translate('Cargo Summary')}</div>
          <div data-testid="cargo-summary-items" className={isMobileScreen ? 'section-body-mobile' : 'section-body'}>
            {cargoSummaryItems()}
          </div>
        </div>
      );
}